// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/create_vision_project.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionProject } from "./vision_project_pb";
import { file_vision_projects_v1_vision_project } from "./vision_project_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/projects/v1/create_vision_project.proto.
 */
export const file_vision_projects_v1_create_vision_project: GenFile = /*@__PURE__*/
  fileDesc("Ci52aXNpb24vcHJvamVjdHMvdjEvY3JlYXRlX3Zpc2lvbl9wcm9qZWN0LnByb3RvEhlwcm90b3MudmlzaW9uLnByb2plY3RzLnYxIpcBChpDcmVhdGVWaXNpb25Qcm9qZWN0UmVxdWVzdBJMCgZwYXJhbXMYASABKAsyPC5wcm90b3MudmlzaW9uLnByb2plY3RzLnYxLkNyZWF0ZVZpc2lvblByb2plY3RSZXF1ZXN0LlBhcmFtcxorCgZQYXJhbXMSDAoEbmFtZRgBIAEoCRITCgtkZXNjcmlwdGlvbhgCIAEoCSKxAQobQ3JlYXRlVmlzaW9uUHJvamVjdFJlc3BvbnNlEk0KBnJlc3VsdBgBIAEoCzI9LnByb3Rvcy52aXNpb24ucHJvamVjdHMudjEuQ3JlYXRlVmlzaW9uUHJvamVjdFJlc3BvbnNlLlJlc3VsdBpDCgZSZXN1bHQSOQoHcHJvamVjdBgBIAEoCzIoLnByb3Rvcy52aXNpb24ucHJvamVjdHMudjEuVmlzaW9uUHJvamVjdGIGcHJvdG8z", [file_vision_projects_v1_vision_project]);

/**
 * @generated from message protos.vision.projects.v1.CreateVisionProjectRequest
 */
export type CreateVisionProjectRequest = Message<"protos.vision.projects.v1.CreateVisionProjectRequest"> & {
  /**
   * @generated from field: protos.vision.projects.v1.CreateVisionProjectRequest.Params params = 1;
   */
  params?: CreateVisionProjectRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.CreateVisionProjectRequest.
 * Use `create(CreateVisionProjectRequestSchema)` to create a new message.
 */
export const CreateVisionProjectRequestSchema: GenMessage<CreateVisionProjectRequest> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_create_vision_project, 0);

/**
 * @generated from message protos.vision.projects.v1.CreateVisionProjectRequest.Params
 */
export type CreateVisionProjectRequest_Params = Message<"protos.vision.projects.v1.CreateVisionProjectRequest.Params"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message protos.vision.projects.v1.CreateVisionProjectRequest.Params.
 * Use `create(CreateVisionProjectRequest_ParamsSchema)` to create a new message.
 */
export const CreateVisionProjectRequest_ParamsSchema: GenMessage<CreateVisionProjectRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_create_vision_project, 0, 0);

/**
 * @generated from message protos.vision.projects.v1.CreateVisionProjectResponse
 */
export type CreateVisionProjectResponse = Message<"protos.vision.projects.v1.CreateVisionProjectResponse"> & {
  /**
   * @generated from field: protos.vision.projects.v1.CreateVisionProjectResponse.Result result = 1;
   */
  result?: CreateVisionProjectResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.CreateVisionProjectResponse.
 * Use `create(CreateVisionProjectResponseSchema)` to create a new message.
 */
export const CreateVisionProjectResponseSchema: GenMessage<CreateVisionProjectResponse> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_create_vision_project, 1);

/**
 * @generated from message protos.vision.projects.v1.CreateVisionProjectResponse.Result
 */
export type CreateVisionProjectResponse_Result = Message<"protos.vision.projects.v1.CreateVisionProjectResponse.Result"> & {
  /**
   * @generated from field: protos.vision.projects.v1.VisionProject project = 1;
   */
  project?: VisionProject | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.CreateVisionProjectResponse.Result.
 * Use `create(CreateVisionProjectResponse_ResultSchema)` to create a new message.
 */
export const CreateVisionProjectResponse_ResultSchema: GenMessage<CreateVisionProjectResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_create_vision_project, 1, 0);

